import React from 'react';
import {
    Page,
    BlockTitle,
    Block,
    Col,
    Row,
    Link,
    Card,
    CardContent,
    Icon,
    Preloader
} from 'framework7-react';

import {API_URL} from '../../../api';

import PageBlock from '../../shared/pageBlock/pageBlock';

export default class extends React.Component {

    state = {
        loading: true,
        error: false,
        contact_person: false,
        org_nr: false,
        terms:''
    }

    componentDidMount(){
        this.loadXhr();
    }

    loadXhr(){

        const eid = this.props.f7route.params.id;

        this.setState({
            loading:true,
        });

        fetch(API_URL+'/org/terms', {
            method: 'POST',
            body: JSON.stringify({
                eid: eid
            })
        })
        .then(response => {
        return response.json()
        })
        .then(data => {
            if(data.err_code === 0){
                this.setState({
                    loading: false,
                    error: false,
                    terms: data.sales_terms
                });
            }else{
                this.setState({
                    loading: false,
                    error: true,
                    error_mgs: data.mgs,
                });
            }
        })
        .catch(err => {
        this.setState({
            loading:true,
            error:true,
            error_mgs: 'En ukjent feil har oppstått, prøv igjen senere.'
        });
        })

    }

    render_bottombar = () => {
        return <PageBlock width="700px" color="#dfe4ea">
        <Row noGap>
          <Col width="100" small="40">
              <BlockTitle>Vilkår og personvern</BlockTitle>
              <Block>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="https://pameldinger.no/cookies">
                Informasjonskapsler (Cookies)
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="https://pameldinger.no/vilkar-for-deltakere">
                Vilkår for deltakere
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="https://pameldinger.no/personvern">
                Personvernerklæring
                </Link>
                </p>
            </Block>
          </Col>
          <Col width="100" small="60">
            <BlockTitle>Bruk Påmeldinger.no på ditt arrangement!</BlockTitle>
            <Block>
                <p>
                Påmeldinger.no er et påmeldingssystem for konferanser, kurs, konserter og events. Vi håndetere betaling og administrativt arbeid i forbindelse med arrangementer.
                </p>
                <Link external target="_blank" href="/">
                  <b>Les mer om Påmeldinger.no</b>
                </Link>
              </Block> 
            </Col>
          </Row>
        </PageBlock>;
    }
    render() {
        return <Page>
            {this.state.loading ?
                <div className="text-align-center" style={{marginTop:'36px',marginBottom:'654px'}}>
                    <Preloader></Preloader>
                    <p>Vent litt</p>
                </div>
            :
            <>
            {this.state.error
            ? 
            <PageBlock width="520px">
                <Card outline style={{color:'#fff', backgroundColor:'#e74c3c',maxWidth:'440px',marginLeft:'auto',marginRight:'auto',marginTop:'36px',marginBottom:'660px'}}>
                    <CardContent>
                        <Icon material="error" style={{marginRight:'12px',marginTop:'-5px'}}/>
                        <span style={{fontSize:'18px'}}>Denne organisasjonen eksisterer ikke.</span>
                    </CardContent>
                </Card>
            </PageBlock>
            :
            <PageBlock width="680px">
                <BlockTitle large>
                Salgs- og påmeldingsvilkår
                </BlockTitle>
                {this.state.terms ?
                <div dangerouslySetInnerHTML={{__html:this.state.terms}} style={{marginBottom:'50px', padding:'20px'}}>

                </div>
                :
                <p>
                    Ingen å vise.
                </p>
                }
            </PageBlock>
            }
            </>
            }
            {this.render_bottombar()}
        </Page>
    }
};
